<div class="meta-row-mascot-ring" aria-hidden="true">
  <img class="meta-row-mascot" src="/public/svgs/robocat.svg" alt="" />
</div>
<div class="meta-text">{{ 'app.components.parentAiAssistant.title' | translate }}</div>
